import { Autocomplete, Switch, Card, Grid, Icon, InputLabel, MenuItem, Select, FormControl, FormControlLabel, Radio, RadioGroup, TextField, Dialog, DialogTitle, DialogContent, DialogActions, Button, Checkbox, LinearProgress } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import { useState, useEffect } from "react";
import { postUploadNoResponse, post, get } from "utils/WebService";
import { errorAlert, successAlert } from "utils/Functions";
import moment from "moment";
import { ESCURO } from "assets/coresTema";

export default function RemessaImport() {
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;

    const [openSaveModel, setOpenSaveModel] = useState(false);
    const [newModelName, setNewModelName] = useState("");

    const [file, setFile] = useState(null);
    const [importMode, setImportMode] = useState("batimento");
    const [selectedCarteira, setSelectedCarteira] = useState("");
    const [carteiras, setCarteiras] = useState([]);
    const [excelColumns, setExcelColumns] = useState([]);
    const [isUploading, setIsUploading] = useState(false);
    const [progressPct, setProgressPct] = useState(0);
    const [progressStatus, setProgressStatus] = useState("");
    
    const [sheets, setSheets] = useState([]);
    const [selectedSheet, setSelectedSheet] = useState(0);

    const [clients, setClients] = useState([]);
    const [selectedClient, setSelectedClient] = useState("");
    
    const [subCarteiras, setSubCarteiras] = useState([]);
    const [selectedSubCarteira, setSelectedSubCarteira] = useState("");
    
    const [operators, setOperators] = useState([]);
    const [selectedPropriedade, setSelectedPropriedade] = useState([]);
    
    const [savedModels, setSavedModels] = useState([]);
    const [selectedModel, setSelectedModel] = useState("");
    const [dataRemessa, setDataRemessa] = useState(moment().format("YYYY-MM-DD"));
    // Vale só para a importação atual (não vai para o modelo): volta a desligar a cada arquivo novo
    const [incluirAcordoAtivoComNovoValor, setIncluirAcordoAtivoComNovoValor] = useState(false);

    useEffect(() => {
        get("/pessoa/list-all").then(res => {
            if (res.list) setClients(res.list);
        }).catch(err => console.error(err));
        
        post("/remessa/modelos", {}).then(res => {
            if (Array.isArray(res)) setSavedModels(res);
        }).catch(err => console.error(err));
        
        get("/carteira/list-all").then(res => {
            if (res && res.list) setCarteiras(res.list);
        }).catch(err => console.error(err));
    }, []);

    useEffect(() => {
        if (!selectedCarteira) {
            setOperators([]);
            return;
        }
        get(`/users/list-all-operators?carteiraId=${selectedCarteira}`).then(res => {
            if (res && res.list) {
                setOperators(res.list);
            } else {
                setOperators([]);
            }
        }).catch(() => setOperators([]));
    }, [selectedCarteira]);

    useEffect(() => {
        if (!selectedClient) {
            setSubCarteiras([]);
            setSelectedSubCarteira("");
            return;
        }
        get(`/pessoa/by-id/${selectedClient}`).then(res => {
            if (res && res.subCarteiras) {
                setSubCarteiras(res.subCarteiras);
                setSelectedSubCarteira("");
            } else {
                setSubCarteiras([]);
                setSelectedSubCarteira("");
            }
        }).catch(() => setSubCarteiras([]));
    }, [selectedClient]);

    // Mapeamento dos campos do sistema com as colunas do Excel
    const [mapping, setMapping] = useState({
        codigoCliente: "",
        cpfCnpj: "",
        nome: "",
        contrato: "",
        vencimento: "",
        emissao: "",
        valor: "",
        descricao: "",
        operador: "",
        email: "",
        telefone: "",
        cep: "",
        logradouro: "",
        numero: "",
        complemento: "",
        bairro: "",
        cidade: "",
        uf: "",
        observacaoFormula: "",
        respeitarFormatacaoCodigoCliente: false,
        linhasRepetidasSaoParcelas: false,
    });

    const handleFileChange = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            const selectedFile = e.target.files[0];
            setFile(selectedFile);
            setIncluirAcordoAtivoComNovoValor(false);

            const formData = new FormData();
            formData.append("file", selectedFile);
            
            postUploadNoResponse("/remessa/upload-columns", formData)
                .then(res => res.json())
                .then(data => {
                    if (data.sheets) setSheets(data.sheets);
                    if (data.columns && data.columns.length > 0) {
                        setExcelColumns(data.columns);
                        setSelectedSheet(0);
                    } else {
                        errorAlert("Nenhuma coluna encontrada no arquivo.");
                    }
                })
                .catch(err => {
                    console.error(err);
                    errorAlert("Erro ao ler o arquivo Excel.");
                });
        }
    };

    const handleMappingChange = (field, value) => {
        setMapping(prev => ({ ...prev, [field]: value }));
    };

    const handleSheetChange = (e) => {
        const newSheetIndex = e.target.value;
        setSelectedSheet(newSheetIndex);
        
        if (file) {
            const formData = new FormData();
            formData.append("file", file);
            formData.append("sheetIndex", newSheetIndex);
            
            postUploadNoResponse("/remessa/upload-columns", formData)
                .then(res => res.json())
                .then(data => {
                    if (data.columns && data.columns.length > 0) {
                        setExcelColumns(data.columns);
                    } else {
                        errorAlert("Nenhuma coluna encontrada na aba selecionada.");
                        setExcelColumns([]);
                    }
                })
                .catch(err => {
                    console.error(err);
                    errorAlert("Erro ao ler as colunas da aba selecionada.");
                });
        }
    };

    const handleProcessImport = () => {
        if (!file) {
            errorAlert("Por favor, selecione um arquivo.");
            return;
        }

        if (importMode === "devolucao") {
            if (!mapping.codigoCliente && !mapping.cpfCnpj) {
                errorAlert("Na devolução em lote, é obrigatório mapear o Código Cliente ou CPF/CNPJ.");
                return;
            }
        } else {
            if (!mapping.codigoCliente || !mapping.nome || !mapping.contrato) {
                errorAlert("Por favor, mapeie todos os campos obrigatórios (*).");
                return;
            }
        }

        if (!selectedCarteira) {
            errorAlert("Por favor, selecione uma Carteira.");
            return;
        }

        setIsUploading(true);
        
        const formData = new FormData();
        formData.append("file", file);
        formData.append("importMode", importMode);
        formData.append("carteiraId", selectedCarteira);
        formData.append("sheetIndex", selectedSheet);
        formData.append("mapping", JSON.stringify(mapping));
        if (selectedClient) {
            formData.append("clienteId", selectedClient);
        }
        if (selectedSubCarteira) {
            formData.append("subCarteiraId", selectedSubCarteira);
        }
        if (selectedPropriedade && selectedPropriedade.length > 0) {
            formData.append("propriedadeUserIds", selectedPropriedade.join(","));
        }
        if (dataRemessa) {
            formData.append("dataRemessa", dataRemessa);
        }
        if (importMode !== "devolucao" && incluirAcordoAtivoComNovoValor) {
            formData.append("incluirAcordoAtivoComNovoValor", "true");
        }

        postUploadNoResponse("/remessa/process-import", formData)
            .then(res => res.json())
            .then(data => {
                if (data.success && data.jobId) {
                    setProgressStatus("Processando... aguarde.");
                    setProgressPct(0);
                    
                    const pollInterval = setInterval(() => {
                        get(`/remessa/import-status/${data.jobId}`)
                            .then(statusData => {
                                if (statusData.status === "PROCESSANDO") {
                                    setProgressPct(statusData.progresso);
                                    setProgressStatus(`Processando... ${statusData.progresso}%`);
                                } else if (statusData.status === "CONCLUIDO" || statusData.status === "ERRO") {
                                    clearInterval(pollInterval);
                                    setIsUploading(false);
                                    
                                    if (statusData.status === "CONCLUIDO") {
                                        successAlert("Remessa processada com sucesso!");
                                    } else {
                                        errorAlert(statusData.resumoTxt || "Erro ao processar arquivo");
                                    }
                                    
                                    if (statusData.resumoTxt) {
                                        const blobTxt = new Blob(["\ufeff" + statusData.resumoTxt], { type: "text/plain;charset=utf-8;" });
                                        const linkTxt = document.createElement("a");
                                        linkTxt.href = URL.createObjectURL(blobTxt);
                                        linkTxt.setAttribute("download", "Resumo_Importacao.txt");
                                        document.body.appendChild(linkTxt);
                                        linkTxt.click();
                                        document.body.removeChild(linkTxt);
                                    }
                                    
                                    if (statusData.inconsistencias && statusData.inconsistencias.length > 0) {
                                        let csvContent = "Linha;Codigo Cliente;Nome;Titulo;Vencimento;Motivo\n";
                                        statusData.inconsistencias.forEach(inc => {
                                            csvContent += `${inc.linha};"${inc.codigoCliente}";"${inc.nome}";"${inc.titulo}";"${inc.vencimento}";"${inc.motivo}"\n`;
                                        });
                                        const blob = new Blob(["\ufeff" + csvContent], { type: "text/csv;charset=utf-8;" });
                                        const link = document.createElement("a");
                                        link.href = URL.createObjectURL(blob);
                                        link.setAttribute("download", "inconsistencias_remessa.csv");
                                        document.body.appendChild(link);
                                        link.click();
                                        document.body.removeChild(link);
                                    }
                                }
                            })
                            .catch(err => {
                                console.error("Erro no polling:", err);
                                clearInterval(pollInterval);
                                setIsUploading(false);
                                errorAlert("Erro ao consultar status da importação.");
                            });
                    }, 2000);
                } else {
                    setIsUploading(false);
                    errorAlert(data.error || "Erro ao iniciar importação.");
                }
            })
            .catch(err => {
                setIsUploading(false);
                console.error("Erro no processamento:", err);
                errorAlert("Erro ao comunicar com o servidor.");
            });
    };

    const handleSaveModel = () => {
        if (!newModelName.trim()) {
            errorAlert("O nome do modelo é obrigatório.");
            return;
        }
        
        const formData = new FormData();
        formData.append("nome", newModelName);
        formData.append("mappingJson", JSON.stringify(mapping));
        if (selectedClient) {
            formData.append("clienteId", selectedClient);
        }
        if (selectedSubCarteira) {
            formData.append("subCarteiraId", selectedSubCarteira);
        }

        postUploadNoResponse("/remessa/modelo/save", formData)
            .then(res => res.json())
            .then(data => {
                if (data.success) {
                    successAlert("Modelo salvo com sucesso!");
                    setOpenSaveModel(false);
                    setNewModelName("");
                    // Recarregar os modelos
                    post("/remessa/modelos", {}).then(r => {
                        if (Array.isArray(r)) setSavedModels(r);
                    });
                } else {
                    errorAlert(data.error || "Erro ao salvar modelo.");
                }
            })
            .catch(err => {
                console.error(err);
                errorAlert("Erro ao salvar o modelo.");
            });
    };
    const handleUpdateModel = () => {
        if (!selectedModel) return;
        const model = savedModels.find(m => m.id === selectedModel);
        if (!model) return;

        const formData = new FormData();
        formData.append("id", selectedModel);
        formData.append("nome", model.nome); // Mantém o nome
        formData.append("mappingJson", JSON.stringify(mapping));
        if (selectedClient) {
            formData.append("clienteId", selectedClient);
        }
        if (selectedSubCarteira) {
            formData.append("subCarteiraId", selectedSubCarteira);
        }

        postUploadNoResponse("/remessa/modelo/save", formData)
            .then(res => res.json())
            .then(data => {
                if (data.success) {
                    successAlert("Modelo atualizado com sucesso!");
                    // Recarregar os modelos
                    post("/remessa/modelos", {}).then(r => {
                        if (Array.isArray(r)) setSavedModels(r);
                    });
                } else {
                    errorAlert(data.error || "Erro ao atualizar modelo.");
                }
            })
            .catch(err => {
                console.error(err);
                errorAlert("Erro ao atualizar o modelo.");
            });
    };
    return (
        <Grid container display="flex" justifyContent="center">
            <Grid item xs={12} md={12}>
                <Card sx={{ p: 2, mb: 3 }}>
                    <Grid container spacing={3}>
                        {/* Seleção do Cliente */}
                        <Grid item xs={12} md={6}>
                            <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Cliente *</InputLabel>
                            <FormControl fullWidth size="small">
                                <Select
                                    value={selectedClient}
                                    onChange={(e) => setSelectedClient(e.target.value)}
                                    displayEmpty
                                   
                                >
                                    <MenuItem value="" disabled>Selecione um cliente...</MenuItem>
                                    {clients.map(c => (
                                        <MenuItem key={c.id} value={c.id}>{c.nomeComum || c.nomeCompleto}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        
                        {/* Seleção de Sub-Carteira (condicional) */}
                        <Grid item xs={12} md={6}>
                            {subCarteiras.length > 0 && (
                                <>
                                    <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Sub-Carteira</InputLabel>
                                    <FormControl fullWidth size="small">
                                        <Select
                                            value={selectedSubCarteira}
                                            onChange={(e) => setSelectedSubCarteira(e.target.value)}
                                            displayEmpty
                                           
                                        >
                                            <MenuItem value="">Nenhuma (Cliente Principal)</MenuItem>
                                            {subCarteiras.map(sc => (
                                                <MenuItem key={sc.id} value={sc.id}>{sc.nome}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </>
                            )}
                        </Grid>

                        {/* Data da Remessa */}
                        <Grid item xs={12} md={6}>
                            <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Data da Remessa</InputLabel>
                            <TextField
                                type="date"
                                fullWidth
                                size="small"
                                value={dataRemessa}
                                onChange={(e) => setDataRemessa(e.target.value)}
                               
                            />
                        </Grid>

                        {/* Upload do Arquivo */}
                        <Grid item xs={12} md={6}>
                            <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>&nbsp;</InputLabel>
                            <MDBox display="flex" gap={2}>
                                <MDButton
                                    variant={darkMode ? "gradient" : "outlined"}
                                    color="info"
                                    component="label"
                                    size="small"
                                    sx={darkMode ? { color: "#ffffff !important", fontWeight: "bold" } : {}}
                                >
                                    <Icon sx={{ mr: 1 }}>cloud_upload</Icon>
                                    Fazer Upload
                                    <input
                                        type="file"
                                        hidden
                                        accept=".xls,.xlsx"
                                        onChange={handleFileChange}
                                    />
                                </MDButton>
                                {file && (
                                    <TextField
                                        size="small"
                                        disabled
                                        fullWidth
                                        value={file.name}
                                       
                                    />
                                )}
                            </MDBox>
                        </Grid>

                        {/* Seleção de Aba */}
                        {sheets.length > 1 && (
                            <Grid item xs={12} md={4}>
                                <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Aba da Planilha</InputLabel>
                                <FormControl fullWidth size="small">
                                    <Select
                                        value={selectedSheet}
                                        onChange={handleSheetChange}
                                        displayEmpty
                                       
                                    >
                                        {sheets.map(s => (
                                            <MenuItem key={s.index} value={s.index}>{s.name}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                        )}

                        {/* Tipo de Importação */}
                        <Grid item xs={12} md={4}>
                            <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Modo de Importação</InputLabel>
                            <FormControl component="fieldset">
                                <RadioGroup
                                    row
                                    value={importMode}
                                    onChange={(e) => setImportMode(e.target.value)}
                                    sx={darkMode ? { color: "#ffffff !important", "& .MuiTypography-root": { color: "#ffffff !important", fontWeight: 500 }, "& .MuiRadio-root": { color: "#ffffff !important", "&.Mui-checked": { color: "#00E676 !important" } } } : {}}
                                >
                                    <FormControlLabel value="batimento" control={<Radio />} label="Batimento" />
                                    <FormControlLabel value="incremental" control={<Radio />} label="Incremental" />
                                    <FormControlLabel value="devolucao" control={<Radio />} label="Devolução em Lote" />
                                </RadioGroup>
                            </FormControl>
                        </Grid>

                        {/* Carteira */}
                        <Grid item xs={12} md={4}>
                            <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Carteira</InputLabel>
                            <FormControl fullWidth size="small">
                                <Select
                                    value={selectedCarteira}
                                    onChange={(e) => {
                                        setSelectedCarteira(e.target.value);
                                        setSelectedPropriedade([]); // Reseta a propriedade ao mudar carteira
                                    }}
                                    displayEmpty
                                   
                                >
                                    <MenuItem value="" disabled>Selecione uma carteira...</MenuItem>
                                    {carteiras.map(c => (
                                        <MenuItem key={c.id} value={c.id}>{c.nome}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        
                        {/* Propriedade (Usuário) */}
                        {selectedCarteira !== "" && (
                            <Grid item xs={12} md={4}>
                                <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Atribuir Propriedade</InputLabel>
                                <FormControl fullWidth size="small">
                                    <Select
                                        multiple
                                        value={selectedPropriedade}
                                        onChange={(e) => {
                                            const val = e.target.value;
                                            if (val.includes("ALL")) {
                                                if (selectedPropriedade.length === operators.length && operators.length > 0) {
                                                    setSelectedPropriedade([]); // Desmarca todos
                                                } else {
                                                    setSelectedPropriedade(operators.map(o => o.id)); // Marca todos
                                                }
                                            } else {
                                                setSelectedPropriedade(typeof val === 'string' ? val.split(',') : val);
                                            }
                                        }}
                                        displayEmpty
                                        renderValue={(selected) => {
                                            if (selected.length === 0) {
                                                return <em>Nenhum (Manter atual)</em>;
                                            }
                                            return operators.filter(op => selected.includes(op.id)).map(op => op.nome).join(', ');
                                        }}
                                       
                                    >
                                        <MenuItem value="ALL" sx={{ minHeight: '36px', py: 0, px: 1.5, mb: 0.5, borderBottom: '1px solid #eee' }}>
                                            <Checkbox checked={selectedPropriedade.length === operators.length && operators.length > 0} size="small" sx={{ p: 0.5, mr: 1 }} />
                                            <MDTypography variant="body2" fontWeight="bold">Marcar todos</MDTypography>
                                        </MenuItem>
                                        <MenuItem disabled value="" sx={{ minHeight: '36px', py: 0, px: 1.5 }}>
                                            <MDTypography variant="caption" fontStyle="italic" color="text">Nenhum (Manter atual)</MDTypography>
                                        </MenuItem>
                                        {operators.map(op => (
                                            <MenuItem key={op.id} value={op.id} sx={{ minHeight: '36px', py: 0, px: 1.5 }}>
                                                <Checkbox checked={selectedPropriedade.indexOf(op.id) > -1} size="small" sx={{ p: 0.5, mr: 1 }} />
                                                <MDTypography variant="body2">{op.nome}</MDTypography>
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                        )}
                        
                        {/* Seleção do Modelo */}
                        <Grid item xs={12} md={12}>
                            <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Modelos de Remessa</InputLabel>
                            <FormControl fullWidth size="small">
                                <Select
                                    value={selectedModel}
                                    onChange={(e) => {
                                        setSelectedModel(e.target.value);
                                        const model = savedModels.find(m => m.id === e.target.value);
                                        if (model && model.mappingJson) {
                                            setMapping(JSON.parse(model.mappingJson));
                                        }
                                    }}
                                    displayEmpty
                                   
                                >
                                    <MenuItem value="">Nenhum (Mapear manualmente)</MenuItem>
                                    {savedModels.map(m => (
                                        <MenuItem key={m.id} value={m.id}>{m.nome}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>

                        {/* Mapeamento de Colunas (só aparece se o arquivo for lido) */}
                        {excelColumns.length > 0 && (
                            <Grid item xs={12}>
                                <MDBox mt={3} p={3} sx={{ border: `1px solid ${darkMode ? ESCURO.borda : '#ddd'}`, borderRadius: '8px', backgroundColor: darkMode ? ESCURO.cartao : 'transparent' }}>
                                    <MDTypography variant="h6" mb={1} color={darkMode ? "white" : "dark"}>Mapeamento de Colunas</MDTypography>
                                    <MDTypography variant="body2" color={darkMode ? "white" : "text"} mb={2} sx={{ opacity: 0.85 }}>
                                        Vincule as colunas lidas do seu arquivo Excel com os campos do sistema.
                                    </MDTypography>

                                    <MDBox mb={3} p={2} sx={{ borderRadius: "8px", backgroundColor: darkMode ? ESCURO.painel : "#f1f3f9", border: `1px solid ${darkMode ? ESCURO.divisoria : '#e0e0e0'}` }}>
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={Boolean(mapping.respeitarFormatacaoCodigoCliente)}
                                                    onChange={(e) => handleMappingChange("respeitarFormatacaoCodigoCliente", e.target.checked)}
                                                    color="success"
                                                />
                                            }
                                            label={
                                                <MDBox>
                                                    <MDTypography variant="button" fontWeight="bold" color={darkMode ? "white" : "dark"}>
                                                        Preservar formatação do Código Cliente
                                                    </MDTypography>
                                                    <MDTypography variant="caption" color={darkMode ? "white" : "text"} display="block" sx={{ opacity: 0.85 }}>
                                                        Mantém caracteres especiais como barras (/), traços (-), pontos (.) e hífens. Desmarque para limpar pontuações mantendo apenas letras e números.
                                                    </MDTypography>
                                                </MDBox>
                                            }
                                        />
                                        <FormControlLabel
                                            sx={{ mt: 1.5 }}
                                            control={
                                                <Switch
                                                    checked={Boolean(mapping.linhasRepetidasSaoParcelas)}
                                                    onChange={(e) => handleMappingChange("linhasRepetidasSaoParcelas", e.target.checked)}
                                                    color="success"
                                                />
                                            }
                                            label={
                                                <MDBox>
                                                    <MDTypography variant="button" fontWeight="bold" color={darkMode ? "white" : "dark"}>
                                                        Linhas repetidas do mesmo débito são parcelas (NF parcelada)
                                                    </MDTypography>
                                                    <MDTypography variant="caption" color={darkMode ? "white" : "text"} display="block" sx={{ opacity: 0.85 }}>
                                                        Linhas com o mesmo título e vencimento para o mesmo devedor entram como parcelas 01, 02, 03... do débito, sem precisar de "P01" no título (títulos antigos com "P01" são reconhecidos). Reimportar o arquivo não duplica, quitados e débitos em acordo ativo não são alterados. Desligado: a linha repetida é recusada como duplicada. Se o arquivo tiver coluna de Parcela mapeada, ela é usada.
                                                    </MDTypography>
                                                </MDBox>
                                            }
                                        />
                                        {importMode !== "devolucao" && (
                                            <FormControlLabel
                                                sx={{ mt: 1.5 }}
                                                control={
                                                    <Switch
                                                        checked={incluirAcordoAtivoComNovoValor}
                                                        onChange={(e) => setIncluirAcordoAtivoComNovoValor(e.target.checked)}
                                                        color="warning"
                                                    />
                                                }
                                                label={
                                                    <MDBox>
                                                        <MDTypography variant="button" fontWeight="bold" color={darkMode ? "white" : "dark"}>
                                                            Incluir como débito novo os contratos de acordo ativo que vierem com outro valor
                                                        </MDTypography>
                                                        <MDTypography variant="caption" color={darkMode ? "white" : "text"} display="block" sx={{ opacity: 0.85 }}>
                                                            Desligado (padrão): contrato de acordo ativo que vem com outro valor (em geral, o valor já abatido pelo cliente) não é alterado nem incluído, e vai para a lista "AVALIAR" do resumo. Ligue só depois de avaliar essa lista, importando um arquivo apenas com os débitos novos de fato, no modo Incremental: eles entram como débito à parte e o contrato do acordo fica como está. Valor igual ao saldo do sistema nunca é incluído. Vale só para esta importação (não é salva no modelo). Quitado que vem com outro valor sempre entra como débito novo e vai para a lista "VERIFICAR".
                                                        </MDTypography>
                                                    </MDBox>
                                                }
                                            />
                                        )}
                                    </MDBox>

                                    {(() => {
                                        let fieldGroups = [];
                                        if (importMode === "devolucao") {
                                            fieldGroups = [
                                                {
                                                    title: "Dados da Devolução",
                                                    subtitle: "Mapeie Código Cliente ou CPF/CNPJ. Opcionalmente, mapeie Contrato e Vencimento para devolução por débito.",
                                                    fields: [
                                                        { key: "codigoCliente", label: "Código Cliente", required: false },
                                                        { key: "cpfCnpj", label: "CPF/CNPJ", required: false },
                                                        { key: "contrato", label: "Contrato (Opcional)", required: false },
                                                        { key: "vencimento", label: "Vencimento (Opcional)", required: false },
                                                    ]
                                                }
                                            ];
                                        } else {
                                            fieldGroups = [
                                                {
                                                    title: "Dados Principais",
                                                    fields: [
                                                        { key: "codigoCliente", label: "Código Cliente*", required: true },
                                                        { key: "cpfCnpj", label: "CPF/CNPJ", required: false },
                                                        { key: "nome", label: "Nome*", required: true },
                                                        { key: "contrato", label: "Contrato*", required: true },
                                                        { key: "vencimento", label: "Vencimento (Opcional - usa Data Remessa)", required: false },
                                                        { key: "emissao", label: "Emissão", required: false },
                                                        { key: "valor", label: "Valor", required: false },
                                                        { key: "descricao", label: "Descrição", required: false },
                                                        { key: "operador", label: "Responsável / Operador", required: false },
                                                    ]
                                                },
                                                {
                                                    title: "Contatos",
                                                    subtitle: "Mapeie a coluna base ou os campos separados. O sistema trata todos os formatos automaticamente.",
                                                    fields: [
                                                        { key: "email", label: "E-mail(s)", required: false },
                                                        { key: "ddd", label: "DDD (opcional se vier separado)", required: false },
                                                        { key: "telefone", label: "Telefone 1 / Principal", required: false },
                                                        { key: "celular", label: "Celular 1", required: false },
                                                        { key: "telefone2", label: "Telefone 2", required: false },
                                                        { key: "celular2", label: "Celular 2", required: false },
                                                    ]
                                                },
                                                {
                                                    title: "Endereço",
                                                    subtitle: "Você pode mapear os campos da tabela separadamente caso venham abertos na planilha.",
                                                    fields: [
                                                        { key: "cep", label: "CEP", required: false },
                                                        { key: "logradouro", label: "Logradouro (Rua, Av...)", required: false },
                                                        { key: "numero", label: "Número", required: false },
                                                        { key: "complemento", label: "Complemento", required: false },
                                                        { key: "bairro", label: "Bairro", required: false },
                                                        { key: "cidade", label: "Cidade", required: false },
                                                        { key: "uf", label: "UF", required: false },
                                                    ]
                                                }
                                            ];
                                        }

                                        return fieldGroups.map((group, gIdx) => (
                                            <MDBox key={gIdx} mb={3}>
                                                <MDTypography variant="subtitle2" sx={{ color: darkMode ? "#00E676 !important" : "#1A73E8 !important", fontWeight: "bold" }} mb={0.5}>
                                                    {group.title}
                                                </MDTypography>
                                                {group.subtitle && (
                                                    <MDTypography variant="caption" color={darkMode ? "white" : "text"} mb={1} display="block" sx={{ opacity: 0.85, lineHeight: 1.2 }}>
                                                        {group.subtitle}
                                                    </MDTypography>
                                                )}
                                                <Grid container spacing={2}>
                                                    {group.fields.map((field) => (
                                                        <Grid item xs={12} sm={6} md={4} key={field.key}>
                                                            <InputLabel sx={{ px: 1, pb: 0.5 }}>
                                                                {field.label}
                                                            </InputLabel>
                                                            <Autocomplete
                                                                freeSolo
                                                                size="small"
                                                                options={excelColumns}
                                                                value={mapping[field.key] || ""}
                                                                onChange={(e, newValue) => handleMappingChange(field.key, newValue || "")}
                                                                onInputChange={(e, newInputValue) => handleMappingChange(field.key, newInputValue || "")}
                                                               
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        {...params}
                                                                        placeholder={field.required ? "Coluna ou Fórmula..." : "Ignorar"}
                                                                        error={field.required && !mapping[field.key]}
                                                                       
                                                                    />
                                                                )}
                                                            />
                                                        </Grid>
                                                    ))}
                                                </Grid>
                                            </MDBox>
                                        ));
                                    })()}
                                    
                                    {importMode !== "devolucao" && (
                                    <MDBox mb={3}>
                                        <MDTypography variant="subtitle2" sx={{ color: darkMode ? "#00E676 !important" : "#1A73E8 !important", fontWeight: "bold" }} mb={0.5}>
                                            Observações (Texto Livre / Fórmula)
                                        </MDTypography>
                                        <MDTypography variant="caption" color={darkMode ? "white" : "text"} mb={1} display="block" sx={{ opacity: 0.85, lineHeight: 1.2 }}>
                                            Escreva o texto livre e inclua o nome das colunas lidas entre chaves para concatenar os valores. <br/>
                                            Exemplo: <strong>Contrato da base {'{'}NomeDaColuna{'}'}</strong>.<br/>
                                            Dica: Para formatar como moeda, use o sufixo <strong>:moeda</strong> (Ex: <strong>{'{'}Valor:moeda{'}'}</strong> gera <strong>R$ 1.500,00</strong>).
                                        </MDTypography>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <TextField 
                                                    fullWidth
                                                    multiline
                                                    rows={2}
                                                    size="small"
                                                    placeholder="Ex: Cliente importado da filial {'{'}Filial{'}'} com taxa de {'{'}Taxa{'}'}%."
                                                    value={mapping.observacaoFormula}
                                                    onChange={(e) => handleMappingChange("observacaoFormula", e.target.value)}
                                                   
                                                />
                                            </Grid>
                                        </Grid>
                                    </MDBox>
                                    )}
                                </MDBox>
                            </Grid>
                        )}
                    </Grid>

                    {/* Controles do Rodapé fora do Grid container para evitar problemas de overflow */}
                    <MDBox mt={3}>
                        {isUploading && (
                            <MDBox mb={2} sx={{ width: '100%', overflow: 'hidden', borderRadius: 1, textAlign: 'center' }}>
                                <MDTypography variant="button" color="info" fontWeight="bold">
                                    {progressStatus}
                                </MDTypography>
                                <LinearProgress variant="determinate" value={progressPct} color="info" sx={{ mt: 1 }} />
                            </MDBox>
                        )}
                        <MDBox display="flex" justifyContent="space-between" flexWrap="wrap" gap={2}>
                            <MDBox display="flex" gap={2} flexWrap="wrap">
                                {selectedModel && (
                                    <MDButton 
                                        variant={darkMode ? "gradient" : "outlined"} 
                                        color="info" 
                                        onClick={handleUpdateModel}
                                        disabled={excelColumns.length === 0}
                                        sx={darkMode ? { color: "#ffffff !important", fontWeight: "bold" } : {}}
                                    >
                                        <Icon sx={{ mr: 1 }}>update</Icon>
                                        Atualizar
                                    </MDButton>
                                )}
                                <MDButton 
                                    variant={darkMode ? "gradient" : "outlined"} 
                                    color="success" 
                                    onClick={() => setOpenSaveModel(true)}
                                    disabled={excelColumns.length === 0}
                                    sx={darkMode ? { color: "#ffffff !important", fontWeight: "bold" } : {}}
                                >
                                    <Icon sx={{ mr: 1 }}>save</Icon>
                                    Salvar Como Novo
                                </MDButton>
                            </MDBox>
                            
                            <MDButton 
                                variant="gradient" 
                                color="info" 
                                onClick={handleProcessImport}
                                disabled={!file || isUploading || !selectedClient}
                                sx={{ color: "#ffffff !important", fontWeight: "bold" }}
                            >
                                {isUploading ? "Iniciando a Importação..." : "Importar"}
                            </MDButton>
                        </MDBox>
                    </MDBox>
                </Card>
            </Grid>

            {/* Dialog para Salvar Modelo */}
            <Dialog open={openSaveModel} onClose={() => setOpenSaveModel(false)} fullWidth maxWidth="sm">
                <DialogTitle>Salvar Modelo de Layout</DialogTitle>
                <DialogContent>
                    <MDTypography variant="body2" color="text" mb={2}>
                        Dê um nome para este mapeamento. Ele ficará disponível para ser reutilizado em futuras importações.
                    </MDTypography>
                    <TextField 
                        autoFocus
                        fullWidth 
                        size="small" 
                        label="Nome do Modelo" 
                        value={newModelName}
                        onChange={(e) => setNewModelName(e.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenSaveModel(false)}>Cancelar</Button>
                    <Button onClick={handleSaveModel} variant="contained" color="primary" sx={{ color: '#fff' }}>
                        Salvar
                    </Button>
                </DialogActions>
            </Dialog>
        </Grid>
    );
}
